import { Carousel } from '@inexture/carousel';
import gryeBgSlier from '@/assets/img/slider/grey-background-slider.png';
import ipadRightHand from '@/assets/img/slider/ipad-right-hand.png';
import leftFinger from '@/assets/img/slider/left-finger-pointed.png';
import RFTrigger from '@/form/register/RFTrigger.tsx';
import { BackgroundImage, Box } from '@inexture/core';

const HomeSlider = () => {
  return (
    <div id="home" className="scroller">
      <Carousel withIndicators height={570} bg="#e8e8e8">
        <Carousel.Slide>
          <BackgroundImage src={gryeBgSlier}>
            <div className="container">
              <Box h={570} className="grid grid-cols-12 items-center h-full">
                <div className="col-span-5">
                  <div className="text-3xl mb-7 text-[var(--mantine-color-primary-filled)]">
                    Management magisch <br /> makkelijk gemaakt!
                  </div>

                  <div className="mb-10 text-gray-600">
                    Gebruiksvriendelijk en betaalbaar Software <br /> applicatie
                    voor het beheer van uw planning, <br /> klanten, werknemers
                    en strijk. Rapportering ...
                  </div>

                  <div className="tp-caption custom_content lfb">
                    <RFTrigger btnProps={{ size: 'lg' }} />
                  </div>
                </div>
                <div className="col-span-7">
                  <div className="absolute bottom-0">
                    <img src={ipadRightHand} alt="Image 1" />
                  </div>

                  <div className="absolute bottom-0 ml-[-100px]">
                    <img src={leftFinger} alt="Image 2" />
                  </div>
                </div>
              </Box>
            </div>
          </BackgroundImage>
        </Carousel.Slide>
      </Carousel>
      <div className="shadow-bg"></div>
    </div>
  );
};

export default HomeSlider;
